var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"blog my-5"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},_vm._l((_vm.blogs),function(item,index){return _c('div',{key:index,staticClass:"col-md-4"},[_c('list-blog',{attrs:{"img":item.img,"title":item.title,"fullname":item.fullname,"pub_date":item.pub_date,"id":item.id}})],1)}),0)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5fef4c4c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/blog/index.vue
// module id = null
// module chunks = 